export function cleanObject<T extends object>(obj?: T): NonNullable<T> {
  if (obj === undefined) {
    return <NonNullable<T>> {};
  }
  return Object.entries(obj)
    .filter(([, v]) => v !== null && v !== undefined)
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), <NonNullable<T>>{});
}
